/** Certification blanche : examens, tentatives, statistiques admin. */
import type { CertExamDefinition, CertExamResult, CertQuestionAnswer, CertQuestionResult } from '@unity-learning/shared';
import { apiGet, apiPost } from './client';

/** Résumé d'un examen disponible ; la forme précise est celle de la page. */
export function getCertificationExams<T>(): Promise<T[]> {
  return apiGet<T[]>('/api/certification/exams');
}

export function getCertificationExam(examId: string): Promise<CertExamDefinition> {
  return apiGet<CertExamDefinition>('/api/certification/exam', { query: { examId } });
}

export interface SubmitExamParams {
  examId: string;
  answers: Record<string, CertQuestionAnswer>;
  startedAt: string | null;
  submissionType: 'manual' | 'timeout';
}

export function submitCertificationExam(params: SubmitExamParams): Promise<CertExamResult> {
  return apiPost<CertExamResult>('/api/certification/submit', params);
}

/** Tentative telle que stockée (colonnes brutes, JSON parfois sérialisé en chaîne). */
export interface StoredCertAttempt {
  id: string;
  exam_id: string;
  score: number;
  max_score: number;
  passed: boolean | number;
  started_at?: string;
  completed_at?: string;
  question_results?: string | unknown[];
  /** Correction déjà lue par le serveur, avec l'explication actuelle des questions (examen fixe). */
  questionResults?: CertQuestionResult[];
  answers?: string | Record<string, unknown>;
  /** Examen fixe de la copie, questions sans validation ; null pour l'Entraînement IA. */
  exam?: CertExamDefinition | null;
  [column: string]: unknown;
}

export function getCertificationAttempts<T = StoredCertAttempt>(): Promise<T[]> {
  return apiGet<T[]>('/api/certification/attempts');
}

export function getCertificationAttempt(attemptId: string): Promise<StoredCertAttempt> {
  return apiGet<StoredCertAttempt>(`/api/certification/attempts/${encodeURIComponent(attemptId)}`);
}

export function getAdminCertificationStats<T>(): Promise<T> {
  return apiGet<T>('/api/certification/admin/stats');
}

export function getAdminCertificationAttempts<T>(): Promise<T[]> {
  return apiGet<T[]>('/api/certification/admin/attempts');
}
